
      var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEsimSupport = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 4.8,
  y: 4.8,
  width: 14.4,
  height: 14.4,
  rx: 2.2,
  stroke: "#000",
  strokeWidth: 1.6
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.8 2a.8.8 0 1 0-1.6 0h1.6ZM7.2 4v.8h1.6V4H7.2ZM8 2h-.8v2h1.6V2H8ZM12.8 2a.8.8 0 0 0-1.6 0h1.6Zm-1.6 2v.8h1.6V4h-1.6Zm.8-2h-.8v2h1.6V2H12ZM16.8 2a.8.8 0 0 0-1.6 0h1.6Zm-1.6 2v.8h1.6V4h-1.6Zm.8-2h-.8v2h1.6V2H16ZM8.8 22a.8.8 0 0 1-1.6 0h1.6Zm-1.6-2v-.8h1.6v.8H7.2Zm.8 2h-.8v-2h1.6v2H8ZM12.8 22a.8.8 0 0 1-1.6 0h1.6Zm-1.6-2v-.8h1.6v.8h-1.6Zm.8 2h-.8v-2h1.6v2H12ZM16.8 22a.8.8 0 0 1-1.6 0h1.6Zm-1.6-2v-.8h1.6v.8h-1.6Zm.8 2h-.8v-2h1.6v2H16ZM22 8.8a.8.8 0 0 0 0-1.6v1.6Zm-2-1.6h-.8v1.6h.8V7.2Zm2 .8v-.8h-2v1.6h2V8ZM22 12.8a.8.8 0 0 0 0-1.6v1.6Zm-2-1.6h-.8v1.6h.8v-1.6Zm2 .8v-.8h-2v1.6h2V12ZM22 16.8a.8.8 0 0 0 0-1.6v1.6Zm-2-1.6h-.8v1.6h.8v-1.6Zm2 .8v-.8h-2v1.6h2V16ZM2 15.2a.8.8 0 0 0 0 1.6v-1.6Zm2 1.6h.8v-1.6H4v1.6ZM2 16v.8h2v-1.6H2v.8ZM2 11.2a.8.8 0 0 0 0 1.6v-1.6Zm2 1.6h.8v-1.6H4v1.6ZM2 12v.8h2v-1.6H2v.8ZM2 7.2a.8.8 0 1 0 0 1.6V7.2Zm2 1.6h.8V7.2H4v1.6ZM2 8v.8h2V7.2H2V8ZM12.17 16.128c-2.384 0-3.792-1.648-3.792-3.92 0-2.272 1.408-3.872 3.696-3.872 2.224 0 3.552 1.52 3.552 3.664 0 .192-.016.384-.016.672h-5.408c.128 1.056.88 1.808 2.032 1.808.896 0 1.392-.352 1.664-.72l1.568.576c-.56 1.088-1.6 1.792-3.296 1.792Zm-1.904-4.688h3.68c-.128-.88-.784-1.52-1.808-1.52-1.008 0-1.648.576-1.872 1.52Z",
  fill: "#000"
})));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<rect x=\"4.8\" y=\"4.8\" width=\"14.4\" height=\"14.4\" rx=\"2.2\" stroke=\"black\" stroke-width=\"1.6\"/>\r\n<path d=\"M8.8 2C8.8 1.55817 8.44183 1.2 8 1.2C7.55817 1.2 7.2 1.55817 7.2 2H8.8ZM7.2 4V4.8H8.8V4H7.2ZM8 2H7.2V4H8H8.8V2H8Z\" fill=\"black\"/>\r\n<path d=\"M12.8 2C12.8 1.55817 12.4418 1.2 12 1.2C11.5582 1.2 11.2 1.55817 11.2 2H12.8ZM11.2 4V4.8H12.8V4H11.2ZM12 2H11.2V4H12H12.8V2H12Z\" fill=\"black\"/>\r\n<path d=\"M16.8 2C16.8 1.55817 16.4418 1.2 16 1.2C15.5582 1.2 15.2 1.55817 15.2 2H16.8ZM15.2 4V4.8H16.8V4H15.2ZM16 2H15.2V4H16H16.8V2H16Z\" fill=\"black\"/>\r\n<path d=\"M8.8 22C8.8 22.4418 8.44183 22.8 8 22.8C7.55817 22.8 7.2 22.4418 7.2 22H8.8ZM7.2 20V19.2H8.8V20H7.2ZM8 22H7.2V20H8H8.8V22H8Z\" fill=\"black\"/>\r\n<path d=\"M12.8 22C12.8 22.4418 12.4418 22.8 12 22.8C11.5582 22.8 11.2 22.4418 11.2 22H12.8ZM11.2 20V19.2H12.8V20H11.2ZM12 22H11.2V20H12H12.8V22H12Z\" fill=\"black\"/>\r\n<path d=\"M16.8 22C16.8 22.4418 16.4418 22.8 16 22.8C15.5582 22.8 15.2 22.4418 15.2 22H16.8ZM15.2 20V19.2H16.8V20H15.2ZM16 22H15.2V20H16H16.8V22H16Z\" fill=\"black\"/>\r\n<path d=\"M22 8.8C22.4418 8.8 22.8 8.44183 22.8 8C22.8 7.55817 22.4418 7.2 22 7.2L22 8.8ZM20 7.2L19.2 7.2L19.2 8.8L20 8.8L20 7.2ZM22 8L22 7.2L20 7.2L20 8L20 8.8L22 8.8L22 8Z\" fill=\"black\"/>\r\n<path d=\"M22 12.8C22.4418 12.8 22.8 12.4418 22.8 12C22.8 11.5582 22.4418 11.2 22 11.2L22 12.8ZM20 11.2L19.2 11.2L19.2 12.8L20 12.8L20 11.2ZM22 12L22 11.2L20 11.2L20 12L20 12.8L22 12.8L22 12Z\" fill=\"black\"/>\r\n<path d=\"M22 16.8C22.4418 16.8 22.8 16.4418 22.8 16C22.8 15.5582 22.4418 15.2 22 15.2L22 16.8ZM20 15.2L19.2 15.2L19.2 16.8L20 16.8L20 15.2ZM22 16L22 15.2L20 15.2L20 16L20 16.8L22 16.8L22 16Z\" fill=\"black\"/>\r\n<path d=\"M2 15.2C1.55817 15.2 1.2 15.5582 1.2 16C1.2 16.4418 1.55817 16.8 2 16.8L2 15.2ZM4 16.8L4.8 16.8L4.8 15.2L4 15.2L4 16.8ZM2 16L2 16.8L4 16.8L4 16L4 15.2L2 15.2L2 16Z\" fill=\"black\"/>\r\n<path d=\"M2 11.2C1.55817 11.2 1.2 11.5582 1.2 12C1.2 12.4418 1.55817 12.8 2 12.8L2 11.2ZM4 12.8L4.8 12.8L4.8 11.2L4 11.2L4 12.8ZM2 12L2 12.8L4 12.8L4 12L4 11.2L2 11.2L2 12Z\" fill=\"black\"/>\r\n<path d=\"M2 7.2C1.55817 7.2 1.2 7.55817 1.2 8C1.2 8.44183 1.55817 8.8 2 8.8L2 7.2ZM4 8.8L4.8 8.8L4.8 7.2L4 7.2L4 8.8ZM2 8L2 8.8L4 8.8L4 8L4 7.2L2 7.2L2 8Z\" fill=\"black\"/>\r\n<path d=\"M12.1701 16.128C9.78606 16.128 8.37806 14.48 8.37806 12.208C8.37806 9.936 9.78606 8.336 12.0741 8.336C14.2981 8.336 15.6261 9.856 15.6261 12C15.6261 12.192 15.6101 12.384 15.6101 12.672H10.2021C10.3301 13.728 11.0821 14.48 12.2341 14.48C13.1301 14.48 13.6261 14.128 13.8981 13.76L15.4661 14.336C14.9061 15.424 13.8661 16.128 12.1701 16.128ZM10.2661 11.44H13.9461C13.8181 10.56 13.1621 9.92 12.1381 9.92C11.1301 9.92 10.4901 10.496 10.2661 11.44Z\" fill=\"black\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/esimSupport.51d737fc3ed5af5e2b1ea2048291e6b9.svg"),
        {
          React: SvgEsimSupport,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      